module.exports = __webpack_public_path__ + "media/warn.41801c67.mp3";